(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apex-coupon"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('apex-coupon')) {
  customElements.define('apex-coupon', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('main');
      if (!this.root || this.root.querySelector('apex-coupon') !== this) return;
      this.outputs = new Map();
      this.update = this.update.bind(this);
      this.observer = new MutationObserver(() => {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      });
      this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-apex-price', 'data-apex-currency', 'data-apex-from'] });
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.outputs?.forEach(output => output.remove());
    }
    update() {
      this.frame = null;
      const value = Number(this.dataset.value);
      const type = this.dataset.type;
      const valid = Number.isFinite(value) && value > 0 && (type === 'fixed' || (type === 'percent' && value <= 100));
      const active = new Set();
      if (valid) this.root.querySelectorAll('price-list[data-apex-currency]').forEach(list => {
        const sale = list.querySelector('sale-price[data-apex-price]');
        if (!sale) return;
        const price = Number(sale.dataset.apexPrice);
        const currency = list.dataset.apexCurrency;
        if (!Number.isFinite(price) || price < 0 || !currency || (type === 'fixed' && currency !== this.dataset.shopCurrency)) return;
        let money;
        try { money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }); } catch { return; }
        const discounted = Math.max(0, Math.round(type === 'percent' ? price * (100 - value) / 100 : price - value * 100));
        const label = (type === 'percent' ? this.dataset.percentLabel : this.dataset.fixedLabel).replace('[value]', type === 'percent' ? String(value) : money.format(value));
        const total = (sale.dataset.apexFrom === 'true' ? this.dataset.fromLabel : this.dataset.afterLabel).replace('[price]', money.format(discounted / 100));
        active.add(list);
        let output = this.outputs.get(list);
        if (!output) {
          output = document.createElement('div');
          output.className = 'apex-coupon-output';
          const badge = document.createElement('div'); badge.className = 'coupon';
          const amount = document.createElement('div'); amount.className = 'total-sale-price';
          output.append(badge, amount); this.outputs.set(list, output); list.after(output);
        }
        if (output.children[0].textContent !== label) output.children[0].textContent = label;
        if (output.children[1].textContent !== total) output.children[1].textContent = total;
      });
      this.outputs.forEach((output, list) => {
        if (!active.has(list)) { output.remove(); this.outputs.delete(list); }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('apex-countdown-expiry')) {
  customElements.define('apex-countdown-expiry', class extends HTMLElement {
    connectedCallback() {
      this.timer = this.previousElementSibling;
      if (this.timer?.tagName !== 'COUNTDOWN-TIMER' || this.timer.getAttribute('expiration-behavior') !== 'leave') return;
      this.expires = Date.parse(this.timer.getAttribute('expires-at'));
      if (!Number.isFinite(this.expires)) return;
      const connection = {};
      this.connection = connection;
      customElements.whenDefined('countdown-timer-flip').then(() => {
        if (!this.isConnected || this.connection !== connection) return;
        this.check = () => {
          clearTimeout(this.timeout);
          const remaining = this.expires - Date.now();
          if (remaining <= 0) {
            this.timer.querySelectorAll('countdown-timer-flip').forEach(flip => flip.updateValue(0));
            document.removeEventListener('visibilitychange', this.check);
          } else {
            this.timeout = setTimeout(this.check, Math.min(remaining, 60000));
          }
        };
        document.addEventListener('visibilitychange', this.check);
        this.check();
      });
    }
    disconnectedCallback() {
      this.connection = null;
      clearTimeout(this.timeout);
      if (this.check) document.removeEventListener('visibilitychange', this.check);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
